import React from "react";
import { Text, Card } from "@ifgengineering/component-library";
import {
  Container,
  DynamicTag,
  LaunchDate,
  LogoTextContainer,
  PrelaunchChildrenWrapper,
  StyledLogo,
  TitleDescription,
} from "./styled";
import noLogoImage from "@assets/cur8/img/no-logo-deal.png";
import { DealLabels } from "./renderDealLabels";
import { Deal } from "@ifgengineering/client-invest-sdk";
import { format } from "date-fns-tz";

type Props = {
  deal: Deal;
  dealLabels: DealLabels;
};

const DealCardPrelaunch: React.FC<Props> = ({ deal, dealLabels }) => {
  const formattedLaunchDate = deal.launchDate
    ? "ON " +
      format(new Date(deal.launchDate), "d MMMM yyyy", {
        timeZone: "UTC",
      })
    : "SOON";

  return (
    <Card elevation={1} background={"SLATE800"} padding={"0"}>
      <LaunchDate>
        <Text type="U14" color="SLATE800">
          🎁 LAUNCHING {formattedLaunchDate}
        </Text>
      </LaunchDate>
      <PrelaunchChildrenWrapper>
        <LogoTextContainer>
          <StyledLogo
            src={deal.investable?.displayImage?.url || noLogoImage}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = noLogoImage;
            }}
          />

          <TitleDescription>
            <Text type="T18" color="WHITE" fontFamily="archiamedium">
              {deal.name}
            </Text>
            <DynamicTag>{dealLabels.tags}</DynamicTag>
            <Text type="P16" color="WHITE">
              {deal.description}
            </Text>
          </TitleDescription>
        </LogoTextContainer>
        <Container>{dealLabels.labels}</Container>
      </PrelaunchChildrenWrapper>
    </Card>
  );
};

export default DealCardPrelaunch;
